"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingView = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const PopupService_1 = __importStar(require("../../../services/PopupService"));
const StorageService_1 = __importStar(require("../../../services/StorageService"));
const component_1 = require("../../../components/site-menu/component");
const backendImport_1 = require("@front/backendImport");
const voices_helper_1 = require("@front/helpers/voices.helper");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
    <div class="dashboard-wrapper">
        <div class="firms-list row">
            <div class="form   col-12 pb-lg-5">
               

                <div class="row mb-2">
					<div class="col-lg-4">
						<h1>${'onboarding.view.title'.t()}</h1>
					</div>					
                </div>
  				
                ${(0, fast_element_1.when)(x => x.onboardingRecord, (0, fast_element_1.html) `<div class="mb-5">                                    
					<div class="card p-4">
						<div class="row">
							<div class="col-lg-8">
								<div class="d-flex gap-3">
									<div class="py-2" style="font-size:55px; margin-left:-16px;">
										<i class="iconsminds-profile"></i>
									</div>
									<div>
										<h1 class="m-0">${'onboarding.view.meet'.t()} ${x => { var _a; return (_a = x.onboardingRecord) === null || _a === void 0 ? void 0 : _a.avatar_config.name; }}</h1>
										<h3>${'onboarding.view.new_employee'.t()}</h3>
									</div>
								</div>
						 
	
								<p class="h6 my-3">${'onboarding.view.description.1'.t()} ${x => { var _a; return (_a = x.onboardingRecord) === null || _a === void 0 ? void 0 : _a.avatar_config.name; }} ${'onboarding.view.description.2'.t()}
								<br/>${'onboarding.view.description.3'.t()} ${x => { var _a; return (_a = x.onboardingRecord) === null || _a === void 0 ? void 0 : _a.avatar_config.name; }} ${'onboarding.view.description.4'.t()}
								</p>

                                ${x => { var _a; return (_a = x.onboardingRecord) === null || _a === void 0 ? void 0 : _a.avatar_config.name; }} ${'onboarding.view.has_info'.t()}

								<ul class="mx-0 mb-3 ps-0">	
                                    <li>${'onboarding.view.step'.t()} 1: <b>${'onboarding.view.step1_info'.t()}</b></li>
                                    ${(0, fast_element_1.repeat)((x, c) => x.onboardingRecord.profession.steps, (0, fast_element_1.html) `
									    <li>${'onboarding.view.step'.t()} ${(x, c) => c.index + 2}: <b>${x => x.title}</b></li>									
                                    `, { positioning: true })}
                                    <li>${'onboarding.view.step'.t()}  ${(x, c) => x.onboardingRecord.profession.steps.length + 2}: <b>${'onboarding.view.knowledge'.t()}</b></li>
								</ul>

								<p style="max-width:500px;">
									${'onboarding.view.learning_description'.t()} ${x => { var _a; return (_a = x.onboardingRecord) === null || _a === void 0 ? void 0 : _a.avatar_config.name; }} ${'onboarding.view.learning_description2'.t()}
								</p>
								
								<button class="btn btn-primary btn-lg" @click="${x => x.talkWithEmployee()}">
									${'onboarding.view.talk_with'.t()} ${x => { var _a; return (_a = x.onboardingRecord) === null || _a === void 0 ? void 0 : _a.avatar_config.name; }}
								</button>														
							</div>
							${(0, fast_element_1.when)(x => x.onboardingRecord.logo, (0, fast_element_1.html) `<div class="col-lg-4">
								<img src="/uploads/${x => x.onboardingRecord.logo.filename}"
								class="card"
								style="width:100%; height:520px; margin-top:-80px; object-fit: cover;" />						
							</div>`)}
						</div>

					   
					</div>
				
				</div>`)}				
            </div>
        </div>

      
    </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `#etapTabs button {
  width: 100%;
}

.avatars-select {
  box-shadow: none;
  background: transparent;
  padding: 0;
  margin: 0;
  height: auto;
}

.avatars-select .name {
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.75rem;
  padding: 0.5rem 1rem;
  background: #fff;
  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);
}

.avatars-select span .me-3 {
  margin-right: 0.5rem;
}`;
const shadowOptions = { "mode": "open" };
let OnboardingView = class OnboardingView extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.error = '';
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.loadData();
        console.log('OnboardingView connected', this.routeParams);
    }
    async loadData() {
        try {
            this.loading = true;
            this.error = '';
            const response = await this.apiService.back.get('onboarding.get', { routeParams: { id: this.routeParams.id } });
            if (response.success) {
                this.onboardingRecord = response.data;
            }
            else {
                this.error = response.error || 'Failed to load onboarding record';
            }
        }
        catch (error) {
            console.error('Error loading onboarding data:', error);
            this.error = 'Failed to load onboarding record';
        }
        finally {
            this.loading = false;
        }
    }
    // Navigation methods
    navigateToList() {
        component_1.SiteMenu.goto.bind(this)('/onboarding/list');
    }
    editRecord() {
        component_1.SiteMenu.goto.bind(this)(`/onboarding/wizard?id=${this.onboardingRecord.id}`);
    }
    async deleteRecord() {
        if (!await this.popupService.confirm('Are you sure you want to delete this onboarding record?')) {
            return;
        }
        try {
            this.loading = true;
            const response = await this.apiService.back.delete('onboarding.delete', { routeParams: { id: this.onboardingRecord.id.toString() } });
            if (response.success) {
                this.notifyService.notify('Onboarding record deleted successfully', 'info');
                this.navigateToList();
            }
            else {
                this.notifyService.notify(response.error || 'Failed to delete onboarding record', 'error');
            }
        }
        catch (error) {
            console.error('Error deleting onboarding record:', error);
            this.notifyService.notify('Failed to delete onboarding record', 'error');
        }
        finally {
            this.loading = false;
        }
    }
    // Talk with employee - implementing the success functionality from onboarding component
    async talkWithEmployee() {
        var _a, _b;
        if (!((_b = (_a = this.onboardingRecord) === null || _a === void 0 ? void 0 : _a.avatar) === null || _b === void 0 ? void 0 : _b.id)) {
            this.notifyService.notify('No avatar available for this onboarding', 'warning');
            return;
        }
        try {
            // Set up avatar like in onboarding success
            const avatarId = this.onboardingRecord.avatar.id.toString();
            this.storageService.set('ai.selectedAvatar', avatarId);
            // Clear any existing model selection since we now have an avatar
            this.storageService.clear('ai.selectedProvider');
            this.storageService.clear('ai.selectedModel');
            this.storageService.set('ai.selectedAIProvider', 'inthub');
            // Navigate to chat
            component_1.SiteMenu.goto.bind(this)('/ai/chat');
        }
        catch (error) {
            console.error('Error setting up chat with employee:', error);
            this.notifyService.notify('Failed to start chat with employee', 'error');
        }
    }
    // Utility methods for template
    getStatusClass(status) {
        switch (status) {
            case 'completed':
                return 'success';
            case 'in_progress':
                return 'warning';
            case 'abandoned':
                return 'danger';
            default:
                return 'secondary';
        }
    }
    getStatusDisplay(status) {
        switch (status) {
            case 'completed':
                return 'Completed';
            case 'in_progress':
                return 'In Progress';
            case 'abandoned':
                return 'Abandoned';
            default:
                return 'Unknown';
        }
    }
    getProgressPercentage() {
        var _a, _b;
        if (!((_a = this.onboardingRecord) === null || _a === void 0 ? void 0 : _a.current_step) || this.onboardingRecord.status === 'completed') {
            return ((_b = this.onboardingRecord) === null || _b === void 0 ? void 0 : _b.status) === 'completed' ? 100 : 0;
        }
        // This is a simplified calculation - you might want to enhance this based on actual step data
        const stepNumber = typeof this.onboardingRecord.current_step === 'number'
            ? this.onboardingRecord.current_step
            : 1; // Default to step 1 if not a number
        const totalSteps = 5; // Adjust based on your onboarding process
        return Math.min((stepNumber / totalSteps) * 100, 100);
    }
    formatDate(dateString) {
        if (!dateString)
            return '-';
        try {
            const date = new Date(dateString);
            return new Intl.DateTimeFormat('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }).format(date);
        }
        catch (error) {
            return dateString;
        }
    }
    getVoiceName(voiceId) {
        var _a;
        // You might want to implement a voice mapping here
        // For now, just return the voice ID
        return ((_a = (0, voices_helper_1.findVoiceById)(voiceId)) === null || _a === void 0 ? void 0 : _a.nameKey.t()) || 'Default';
    }
    renderKnowledgeItems() {
        var _a;
        if (!((_a = this.onboardingRecord) === null || _a === void 0 ? void 0 : _a.knowledge_ids) || this.onboardingRecord.knowledge_ids.length === 0) {
            return '<div class="list-group-item text-muted text-center">No knowledge items available</div>';
        }
        return this.onboardingRecord.knowledge_ids.map((id, index) => `
            <div class="list-group-item d-flex justify-content-between align-items-center">
                <div>
                    <h6 class="mb-1">Knowledge Item ${index + 1}</h6>
                    <p class="mb-1 text-muted small">ID: ${id}</p>
                </div>
                <span class="badge badge-primary badge-pill">${index + 1}</span>
            </div>
        `).join('');
    }
};
exports.OnboardingView = OnboardingView;
__decorate([
    (0, client_1.RWSInject)(PopupService_1.default),
    __metadata("design:type", typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object)
], OnboardingView.prototype, "popupService", void 0);
__decorate([
    (0, client_1.RWSInject)(StorageService_1.default),
    __metadata("design:type", typeof (_b = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _b : Object)
], OnboardingView.prototype, "storageService", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof backendImport_1.IOnboarding !== "undefined" && backendImport_1.IOnboarding) === "function" ? _c : Object)
], OnboardingView.prototype, "onboardingRecord", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], OnboardingView.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], OnboardingView.prototype, "error", void 0);
exports.OnboardingView = OnboardingView = __decorate([
    (0, client_1.RWSView)('onboarding-view', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], OnboardingView);
OnboardingView.defineComponent();
